import types from './types';

const clearError = () => ({
  type: types.OUTCOME_CLEAR_ERROR,
});

const createOutcome = ({ project, ...outcome }) => ({
  type: types.OUTCOME_CREATE,
  payload: { project, ...outcome },
});

const createOutcomesucceeded = ({ ...outcome }) => ({
  type: types.OUTCOME_CREATE_SUCCEEDED,
  payload: { ...outcome },
});

const createOutcomeFailed = ({ message }) => ({
  type: types.OUTCOME_CREATE_FAILED,
  payload: { message },
});

const deleteOutcome = ({ project, id }) => ({
  type: types.OUTCOME_DELETE,
  payload: { project, id },
});

const deleteOutcomesSucceeded = payload => ({
  type: types.OUTCOME_DELETE_SUCCEEDED,
  payload,
});

const deleteOutcomeFailed = ({ message }) => ({
  type: types.OUTCOME_DELETE_FAILED,
  payload: { message },
});

const fetchOutcome = ({ project, id }) => ({
  type: types.OUTCOME_FETCH,
  payload: { project, id },
});

const fetchOutcomesucceeded = ({ ...outcome }) => ({
  type: types.OUTCOME_FETCH_SUCCEEDED,
  payload: { ...outcome },
});

const fetchOutcomeFailed = ({ message }) => ({
  type: types.OUTCOME_FETCH_FAILED,
  payload: { message },
});

const listOutcomes = ({ project }) => ({
  type: types.OUTCOMES_LIST,
  payload: { project },
});

const listOutcomesSucceeded = payload => ({
  type: types.OUTCOMES_LIST_SUCCEEDED,
  payload,
});

const listOutcomesFailed = ({ message }) => ({
  type: types.OUTCOMES_LIST_FAILED,
  payload: { message },
});

const updateOutcome = ({ project, id, ...outcome }) => ({
  type: types.OUTCOME_UPDATE,
  payload: { project, id, ...outcome },
});

const updateOutcomesucceeded = ({ ...outcome }) => ({
  type: types.OUTCOME_UPDATE_SUCCEEDED,
  payload: { ...outcome },
});

const updateOutcomeFailed = ({ message }) => ({
  type: types.OUTCOME_UPDATE_FAILED,
  payload: { message },
});

export default {
  clearError,
  createOutcome,
  createOutcomeFailed,
  createOutcomesucceeded,
  deleteOutcome,
  deleteOutcomeFailed,
  deleteOutcomesSucceeded,
  fetchOutcome,
  fetchOutcomeFailed,
  fetchOutcomesucceeded,
  listOutcomes,
  listOutcomesFailed,
  listOutcomesSucceeded,
  updateOutcome,
  updateOutcomeFailed,
  updateOutcomesucceeded,
};
